import { registerComponent } from '@gig/magic-common';
import { default as LoyaltyTierContainer } from './loyalty-tier-container.vue?shadowMode';

registerComponent(LoyaltyTierContainer);
